import { jsx as _jsx } from "react/jsx-runtime";
// Retrieved from https://reactsvgicons.com/boxicons
export const BxsChevronUp = (props) => {
    return (_jsx("svg", { viewBox: "0 0 24 24", fill: "currentColor", height: "1em", width: "1em", ...props, children: _jsx("path", { d: "M6.293 13.293l1.414 1.414L12 10.414l4.293 4.293 1.414-1.414L12 7.586z" }) }));
};
